import React, { ReactElement } from 'react';
import { FormHorizontal } from '~/components/form/layout';
import { McmPhotoType } from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { useZodFormFieldSingleValue } from '~/components/zod/ZodForm';
import FormGroup from '~/components/form/FormGroup';
import { format_money } from '~/components/Money';
import McmPhotoJob from '~/tenants/mcm/performable/photo/McmPhotoJob';
import ZodFieldCards from '~/components/zod/ZodFieldCards';

export default function McmPhotoForm(props: TenantPerformableFormProps<McmOrderContext>): ReactElement {
  const types = Object.values(McmPhotoType)
    .filter(
      (type) => props.persona !== PersonaType.CUSTOMER || ![McmPhotoType.RESHOOT, McmPhotoType.ECONOMY].includes(type),
    )
    .map((type) => {
      const calc = McmPhotoJob.calculatePhotos(props.context, type);

      return {
        value: type,
        cost: calc.revenue,
        title: calc.name,
        description: `${calc.range} Photos`,
      };
    });

  const type = useZodFormFieldSingleValue<McmPhotoType>('type');

  return (
    <FormGroup>
      <FormHorizontal name="type" label="Photo Type">
        <ZodFieldCards name="type" options={types} />
      </FormHorizontal>
      {type === McmPhotoType.INTERIOR_EXTERIOR && (
        <FormHorizontal name="extra_photos" label="Extra Photos">
          <ZodFieldSelect
            name="extra_photos"
            options={[
              {
                label: 'No Extra Photos',
                value: '0',
              },
              {
                label: `5 Extra Photos (${format_money(McmPhotoJob.calculateExtra(5))})`,
                value: '5',
              },
              {
                label: `10 Extra Photos (${format_money(McmPhotoJob.calculateExtra(10))})`,
                value: '10',
              },
              {
                label: `15 Extra Photos (${format_money(McmPhotoJob.calculateExtra(15))})`,
                value: '15',
              },
              {
                label: `20 Extra Photos (${format_money(McmPhotoJob.calculateExtra(20))})`,
                value: '20',
              },
            ]}
          />
        </FormHorizontal>
      )}
    </FormGroup>
  );
}
